import React, { FunctionComponent, useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// TODO: type this component
import OnImagesLoaded from 'react-on-images-loaded';

import { getQueryParam } from '@client/helpers/getQueryParam';
import { getTrackingForTrafficSource } from '@client/helpers/tracking';
import MyLoungeWrapperLegacy from '@client/components/mylounge/MyLoungeWrapper';
import {
    getMylounge,
    getTabs,
    getSelectedFilter,
    getErrors as getMyLoungeErrors,
    getHasCampaigns,
} from '@client/redux/modules/mylounge-legacy/selectors';
import {
    fetchMyLounge,
    fetchOpenCampaigns,
    updateImagesLoaded,
} from '@client/redux/modules/mylounge-legacy/actions';
import {
    fetchFlashMessages,
    showHeaderFlashMessage,
} from '@client/redux/modules/flashMessage/actions';
import {
    saveTrackingData
} from '@client/redux/modules/tracking/actions';
import {
    fetchCampaignNotificationTags
} from '@client/redux/modules/pushNotification/actions';
import {
    getErrors,
    getLoading
} from '@client/redux/modules/routing/selectors';
import { getClientDevice } from '@client/redux/modules/clientDevice/selectors';

import { loadTrackData } from './common/routingHelpers';
import { extractError, isClient, track } from '../helpers';
import { TRACK_DATA, FLASH_MESSAGE_TYPE_ERROR } from '../config/constants';

interface Props {
    params: {
        filterTag?: string;
    },
    location: {
        [k in string]: string | number;
    },
    route: {
        props: {
            config: {
                appdomainid: number;
            };
            translations: {
                errors: {
                    [k in string]: string;
                };
            }
        }
    }
}

export const MyLounge: FunctionComponent<Props> = ({ params, location, route }) => {
    const { config, translations } = route.props || {};
    // we prefetch in the server side
    const [shouldFetch, setShouldFetch] = useState(false);

    const dispatch = useDispatch();
    const mylounge = useSelector(getMylounge);
    const routeLoading = useSelector(getLoading);
    const routeLoadingErrors = useSelector(getErrors);
    const clientDevice = useSelector(getClientDevice);
    const hasCampaigns = useSelector(getHasCampaigns);
    const tabs = useSelector(getTabs);
    const selectedFilter = useSelector(getSelectedFilter);
    const myLoungeErrors = useSelector(getMyLoungeErrors);

    const { filterTag } = params;

    // TODO: review if we need this functionality
    const onImagesLoaded = useCallback(() => {
        dispatch(updateImagesLoaded(true));
    }, [dispatch]);

    useEffect(() => {
        if (!isClient()) {
            return;
        }

        const error = extractError(myLoungeErrors);
        if (error) {
            if (error.error.code && translations.errors[error.error.code]) {
                dispatch(showHeaderFlashMessage(FLASH_MESSAGE_TYPE_ERROR, translations.errors[error.error.code]));
            }

            return;
        }
        dispatch(fetchFlashMessages());
        dispatch(fetchCampaignNotificationTags(config.appdomainid));

        const trafficSource = getQueryParam(window.location.search, 'trafficSource');
        loadTrackData().then(data => {
            dispatch(saveTrackingData(data));
            track(TRACK_DATA, { ...data, ...getTrackingForTrafficSource({ trafficSource }) });
        });
    }, []);

    useEffect(() => {
        // This unlocks the fetching for next requests
        if (!shouldFetch && mylounge.tabs.length) {
            setShouldFetch(true);
            return;
        }

        const date = getQueryParam(window.location.search, 'date') || 'now';

        if (!tabs.length) {
            dispatch(fetchMyLounge({ activeTab: filterTag, date }));

            return;
        }

        const sameTabTag = selectedFilter === filterTag;
        const isValidTabTag = tabs.findIndex((tab: { tag: string }) => tab.tag === filterTag) === -1;
        if (!filterTag || sameTabTag || isValidTabTag) {
            return;
        }

        dispatch(fetchOpenCampaigns(filterTag, { date }));
    }, [dispatch, tabs, selectedFilter, filterTag]);

    if (!hasCampaigns) {
        return null;
    }

    // TODO: check rendering count
    return (
        isClient() && <OnImagesLoaded onLoaded={onImagesLoaded}>
            <MyLoungeWrapperLegacy
                routeLoading={routeLoading}
                routeLoadingErrors={routeLoadingErrors}
                mylounge={mylounge}
                clientDevice={clientDevice}
                params={params}
                location={location}
            />
        </OnImagesLoaded>
    );
};

export default MyLounge;
